/**
 * バリデーション関連の定数
 */

// ログイン画面向けのバリデーション定数
export const LOGIN_VALIDATION_MESSAGES = {
  REQUIRED_FIELD: '必須の入力項目です'
} as const

// バリデーションメッセージ
// TODO: 肥大化した場合、目的の文言を捜すのが大変になるため、機能別に分割することを検討
export const VALIDATION_MESSAGES = {
  // TODO: 並び順や構造は後で使いやすいように検討したほうがよいかも

  // 汎用 - 必須入力
  REQUIRED_INPUT: '必須入力です',
  // TODO: REQUIRED_INPUTと統合したほうがよさそう
  REQUIRED_INPUT2: '入力必須です',
  REQUIRED_ITEM: '必須項目です',

  // 汎用 - フォーマット
  EMAIL_FORMAT: 'メールアドレスの形式が正しくありません',
  PHONE_FORMAT: '電話番号の形式が正しくありません',
  NUMBER_FORMAT: '数値を入力してください',
  DATE_FORMAT: '日付の形式が正しくありません',
  POSITIVE_NUMBER: '正の数を入力してください',
  INTEGER: '整数を入力してください',
  NUMBER: '数値を入力してください',

  // 汎用 - その他
  INPUT_IS_INVALID: '入力項目に誤りがあります。',
  UNKNOWN_ERROR: '不明なエラー',

  // 関数型
  MIN_LENGTH: (min: number) => `${min}文字以上で入力してください`,
  MAX_LENGTH: (max: number) => `${max}文字以内で入力してください`,
  MIN_VALUE: (min: number) => `${min}以上の値を入力してください`,
  MAX_VALUE: (max: number) => `${max}以下の値を入力してください`,
  STEP_VALUE: (step: number) => `${step}刻みで入力してください`,
  REQUIRED_FIELDS_NOT_ENOUGH: (fieldNames: string[]) =>
    `必須フィールドが不足しています: ${fieldNames.join(', ')}`,
  VALIDATION_ERROR: (message: string) => `バリデーションエラー: ${message}`,

  // 特定用途
  DUPLICATE: 'この値は既に登録されています',
  INVALID_FORMAT: '入力形式が正しくありません',
  INVALID_URL: 'URLの形式が正しくありません',
  PASSWORD_WEAK: 'パスワードは8文字以上で英数字を含む必要があります',
  CONFIRM_PASSWORD: 'パスワードが一致しません',
  TRUCK_MODEL_NAME_REQUIRED: '車種名称は必須です',
  TRUCK_GROUP_NAME_REQUIRED: '車両グループ名称は必須です',
  TRUCK_MODEL_CODE_REQUIRED: '車種コードは必須です',
  TRUCK_CLASS_NAME_REQUIRED: '車格名称は必須です',
  TRUCK_CLASS_CODE_REQUIRED: '車格コードは必須です',
  DEPARTURE_TIME_RESTRICTION_BOTH_REQUIRED:
    '発地の到着時間制限は開始時刻と終了時刻の両方を入力してください',
  SHIPPING_DATE_REQUIRED: '配車日は必須項目です',
  /** 経由地の到着時刻（#5548）は矢羽根の発時刻〜着時刻の範囲内 */
  WAYPOINT_ENTRY_TIME_OUT_OF_RANGE:
    '経由地の到着時刻は発地の時刻から着地の時刻の範囲内で入力してください',
  /** 経由地の到着時刻（#5548）は経由地の並び順に単調 */
  WAYPOINT_ENTRY_TIME_NOT_ORDERED:
    '経由地の到着時刻は経由地の並び順どおりに入力してください',
  /**
   * [発地着制限-開始 < 発地着制限-終了]
   */
  DEPARTURE_TIME_RESTRICTION_START_SHOULD_BE_BEFORE_DEPARTURE_TIME_RESTRICTION_END:
    '発地の到着時間制限の終了時刻は開始時刻より後に設定してください',
  /**
   * [同一日のみ] 発地着制限-開始 < 着地着制限-開始（同時刻は不可）
   */
  DEPARTURE_TIME_RESTRICTION_START_SHOULD_BE_BEFORE_ARRIVAL_TIME_RESTRICTION_START_IN_SAME_DAY:
    '同一日の場合、発地の到着時間制限の開始時刻は、着地の到着時間制限の開始時刻より前にする必要があります。',
  /**
   * [同一日のみ] 発地着制限-終了 <= 着地着制限-終了（同時刻は可）
   */
  DEPARTURE_TIME_RESTRICTION_END_SHOULD_BE_BEFORE_ARRIVAL_TIME_RESTRICTION_END_IN_SAME_DAY2:
    '同一日の場合、着地の到着時間制限の終了時刻は発地の到着時間制限の終了時刻より前にできません',
  /**
   * [着地着制限-開始 < 着地着制限-終了]
   */
  ARRIVAL_TIME_RESTRICTION_START_SHOULD_BE_BEFORE_ARRIVAL_TIME_RESTRICTION_END:
    '着地の到着時間制限の終了時刻は開始時刻より後に設定してください',
  START_TIME_SHOULD_BE_BEFORE_END_TIME:
    '終了時刻は開始時刻より後に設定してください',
  OUT_OF_DEPARTURE_TIME_RESTRICTION: (
    restrictionStart: Date,
    restrictionEnd: Date
  ) =>
    `発時間制限外(${restrictionStart.getHours()}:${restrictionStart.getMinutes().toString().padStart(2, '0')}~${restrictionEnd.getHours()}:${restrictionEnd.getMinutes().toString().padStart(2, '0')})`,
  // TODO: OUT_OF_DEPARTURE_TIME_RESTRICTION と統合すべきでは?
  OUT_OF_DEPARTURE_TIME_RESTRICTION2: (
    restrictionStart: string,
    restrictionEnd: string
  ) => `発時間制限外(${restrictionStart}~${restrictionEnd})`,
  OUT_OF_ARRIVAL_TIME_RESTRICTION: (
    restrictionStart: Date,
    restrictionEnd: Date
  ) =>
    `着時間制限外(${restrictionStart.getHours()}:${restrictionStart.getMinutes().toString().padStart(2, '0')}~${restrictionEnd.getHours()}:${restrictionEnd.getMinutes().toString().padStart(2, '0')})`,
  // TODO: OUT_OF_ARRIVAL_TIME_RESTRICTION と統合すべきでは?
  OUT_OF_ARRIVAL_TIME_RESTRICTION2: (
    restrictionStart: string,
    restrictionEnd: string
  ) => `着時間制限外(${restrictionStart}~${restrictionEnd})`,
  // TODO: OUT_OF_DEPARTURE_TIME_RESTRICTION, OUT_OF_ARRIVAL_TIME_RESTRICTION と統合すべきでは?
  OUT_OR_DEPARTURE_ARRIVAL_TIME_RESTRICTION: (
    departureRestrictionStart: string,
    departureRestrictionEnd: string,
    arrivalRestrictionStart: string,
    arrivalRestrictionEnd: string
  ) =>
    `発・着時間制限外(${departureRestrictionStart}~${departureRestrictionEnd}), (${arrivalRestrictionStart}~${arrivalRestrictionEnd})`,
  CANNOT_UPDATE_SCHEDULE_BECAUSE_OF: (reasons: string[]) =>
    `指定された時間は、${reasons.join(', ')}のため更新できません`,
  ARRIVAL_TIME_RESTRICTION_BOTH_REQUIRED:
    '着地の到着時間制限は開始時刻と終了時刻の両方を入力してください',
  CANNOT_ADD_SHIPMENT_ORDER_TO_DISPATCHED_VEHICLE: (status: string) =>
    `${status}状態の車両に配送依頼を追加することはできません。`,
  REFRESH_TO_FIND_DISPATCH_DETAIL:
    '配車明細が見つかりません。画面を更新してください。',
  OUT_OF_RESTRICTION_TIME: '時間制限外です',
  OUT_OF_RESTRICTION_TIME2: '時間制限の範囲外です',
  CANNOT_ADD_SHIPMENT_ORDER_BECAUSE_OF_RELATING_TO_TOUR:
    '実績作成済みの為、配車依頼を追加できません',
  CANNOT_OPERATE_DETAIL_WHILE_SAVING:
    '保存中のため操作できません。保存の完了後にもう一度お試しください',
  CANNOT_DISPATCH_SPOT_OTHER_DATE: 'スポット車両のため、別日には配車できません',
  CANNOT_DISPATCH_REGULAR_EXPIRED: 'レギュラー枠の有効期間外には配車できません',
  CANNOT_EDIT_DISPATCH_BECAUSE_OF_RELATING_TO_TOUR:
    '運行実績として連携済のため編集できません',
  INPUT_ORDER_NO: '配送依頼Noを入力してください',
  ORIGIN_AND_DESTINATION_REQUIRED: '発地と着地は必須です',
  SELECT_TYPE: '種別を選択してください',
  SELECT_PARTNER: '先にパートナーを選択してください',
  SELECT_TRUCK: '先に車両番号を選択してください',
  SELECT_PACKAGE_CATEGORY: '荷姿を選択してください',
  SELECT_SITE: '地点を選択してください',
  INPUT_PACKAGE_COUNT: '荷姿数を入力してください',
  SPLIT_QUANTITY_MISMATCH: '分割した品目の合計数量が分割前の数量と一致しません',
  INPUT_AMOUNT: '金額を入力してください',
  INSUFFICIENT_ROUTES:
    '有効な配送ルートが不足しています。発地と着地を選択してください。',
  AFTER_START_DATE: '開始日時より後に設定してください',
  // 束ねの日付統一モーダル: 揃えた結果「着日 < 発日」になる依頼がある場合
  DELIVERY_DATE_BEFORE_SHIPPING_DATE: '着日は発日以降の日付を選択してください',
  ADDITIONAL_FARES_INPUT_TOTAL_FARE:
    '支払側附帯費用を追加する際は合計運賃を入力してください。',
  INPUT_TON_KILO_CONTRACT_TOTAL: `トンキロ契約の場合は数量 *
距離の合計を入力してください`,
  // 日付ピッカー関連
  INVALID_DATE_SELECTION: '選択できない日付です',
  INVALID_MONTH_SELECTION: '選択できない年月です',
  DATE_INPUT_FORMAT: '「2024-05-22」や「20240522」のように入力してください',
  MONTH_INPUT_FORMAT: '「2024-05」や「202405」のように入力してください',
  TIME_INPUT_FORMAT: '時刻は「12:30」や「1230」のように入力してください',
  DATETIME_INPUT_FORMAT:
    '「2024-05-22 12:30」や「202405221230」\nのように入力してください',
  TIME_FORMAT_HHMM: '「15:00」または「1500」のように入力してください',
  INVALID_TIME_SELECTION: '選択できない時刻です',
  SELECT_FILE: 'ファイルを選択してください',
  MIN_ONE_DC_REQUIRED: '拠点は最低1つ以上選択してください',
  MIN_ONE_PARTNER_REQUIRED: 'パートナーは最低1つ以上選択してください',
  TRUCK_TYPE_NAME_REQUIRED: '車両属性名称は必須です',
  TRUCK_TYPE_CODE_REQUIRED: '車両属性コードは必須です',
  SET_DATE_AFTER_APPLY_START: '適用開始日以降の日付を設定してください',
  INPUT_START_END_TIME: '開始・終了時間を入力してください',
  INPUT_NUMBER_BELOW_OR_EQUAL_BASE_HOURS:
    '基本時間以下の数値を入力してください',
  SELECT_AT_LEAST_ONE_START_AREA_OR_SITE:
    '開始地点(エリア)または開始地点(倉庫等)のいずれかを1つ以上選択してください',
  SELECT_AT_LEAST_ONE_DESTINATION_AREA_OR_SITE:
    '配送先地点(エリア)または配送先地点(倉庫等)のいずれかを1つ以上選択してください',
  DEPARTURE_TIME_RESTRICTION_SHOULD_BE_OUT_OF_ARRIVAL_TIME_RESTRICTION:
    '発地と着地の時間制限が交差しないように設定してください',
  ARRANGE_START_TIME: (startTime: string) => ({
    BETWEEN: (restrictionStart: string, restrictionEnd: string) =>
      `矢羽根の開始時間(${startTime})を発時間制限(${restrictionStart}〜${restrictionEnd})の間に設定してください`
  }),
  ARRANGE_END_TIME: (startTime: string) => ({
    BETWEEN: (restrictionStart: string, restrictionEnd: string) =>
      `矢羽根の終了時間(${startTime})を着時間制限(${restrictionStart}〜${restrictionEnd})の間に設定してください`
  }),
  REVERT_STATUS_INTO: (targetStatusLabel: string) => ({
    FOR_ADDING_SHIPPING_ORDER_OF: (statusLabel: string) =>
      `${statusLabel}の配車に配送依頼を追加するには、ステータスを${targetStatusLabel}に戻す必要があります。`,
    FOR_EDITING_SHIPPING_ORDER_OF: (statusLabel: string) =>
      `${statusLabel}の配車に配送依頼を編集するには、ステータスを${targetStatusLabel}に戻す必要があります。`
  }),
  SPECIFY_DEPARTURE_TIME_BETWEEN: (start: string, end: string) => ({
    TO_DISPATCH: `指定された時間は、発時間制限(${start}~${end})外のため配車できません`
  }),
  SPECIFY_ARRIVAL_TIME_BETWEEN: (start: string, end: string) => ({
    TO_DISPATCH: `指定された時間は、着時間制限(${start}~${end})外のため配車できません`
  }),
  SELECT_DC: '拠点が選択されていません',
  REASON_TO_REJECT_REQUIRED: '却下理由は必須です',
  CONFIRM_EACH_ERRORS:
    '入力項目に誤りがあります。各項目のエラーをご確認ください。',
  // TODO: CONFIRM_EACH_ERRORS と文言が似ているため、使い分けがわかりにくい。整理すべき
  CONFIRM_EACH_ERROR_MESSAGES:
    '入力項目に誤りがあります。各項目のエラーメッセージを確認してください。',
  INPUT_SHIPPING_DATE_AND_DELIVERY_DATE: '発送日時と着日時を入力してください',
  SHIPPING_ORDER_IS_EMPTY: '配送依頼が存在しません',
  CSV_FILE_ONLY: (x: string) =>
    `CSVファイルのみアップロード可能です。選択されたファイルの種類: ${x}`,
  // TODO: SELECT_DCを変更したほうが良い？
  SELECT_DC2: '拠点を選択してください',
  TARGET_DATE_RANGE_EXCEEDED: '期間は7日以内で指定してください',

  // WARNING MESSAGE
  INVALID_PARTNER: '配送依頼の指定パートナーと一致していません',

  WEIGHT_DISPLAY_FRACTION_DIGITS_OUT_OF_RANGE:
    '選択中の単位で指定できる小数桁数の上限を超えています'
} as const

// バリデーション制限値
export const VALIDATION_LIMITS = {
  TEXT: {
    SHORT: 50,
    MEDIUM: 200,
    LONG: 1000,
    EXTRA_LONG: 5000
  },
  NUMBER: {
    MAX_INTEGER: 999999999,
    MIN_POSITIVE: 0.01,
    DECIMAL_PLACES: 2,
    MAX_DECIMAL_PLACES: 4
  },
  FILE: {
    MAX_SIZE: 10 * 1024 * 1024, // 10MB
    ALLOWED_EXTENSIONS: ['.pdf', '.jpg', '.jpeg', '.png', '.xlsx', '.csv'],
    ALLOWED_IMAGE_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif'],
    ALLOWED_DOCUMENT_EXTENSIONS: ['.pdf', '.xlsx', '.csv', '.doc', '.docx']
  },
  PASSWORD: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 128
  },
  EMAIL: {
    MAX_LENGTH: 254
  },
  PHONE: {
    MIN_LENGTH: 10,
    MAX_LENGTH: 15
  },
  DATE: {
    TRANSFER_DEADLINE: '20日'
  }
} as const

/**
 * 名称に使えない文字を利用者に示すときのラベル（#5029）。
 *
 * 「異体字」「不可視文字」のような分類名は利用者の語彙になく、何を直せばよいかが
 * 伝わらない。実際に弾いた文字そのものを添える。
 *
 * 不可視文字と空白はエラーにせず取り除くため、ここには現れない。
 *
 * 判定ロジックは `@/utils/forbidden-name-characters` にある。日本語リテラルを
 * 定数へ寄せる ESLint ルール（`no-restricted-syntax`）は `src/constants/**` で
 * 無効になっているため、文言だけをここに置く。
 */
export const FORBIDDEN_NAME_CHARACTER_LABELS = {
  /**
   * 字形を持たない文字。私用領域はフォント次第、未割当は豆腐（□）として
   * 描画されるため、「」で囲んでそのまま見せても利用者が識別できない。
   */
  NOT_DISPLAYABLE: (codePoints: string) => `表示できない文字（${codePoints}）`,
  /** そのまま見せられる文字。 */
  VISIBLE: (grapheme: string) => `「${grapheme}」`,
  /** 列挙が上限を超えたときに添える語。 */
  OVERFLOW: ' ほか',
  /** 列挙できなかったときのメッセージ。 */
  MESSAGE_WITHOUT_LABELS: '入力できない文字があります',
  /** 列挙できたときのメッセージ。 */
  MESSAGE: (labels: string) => `入力できない文字があります: ${labels}`
} as const
